export default __webpack_public_path__ + "static/media/hourGlass.88b45b9f.svg";